import { render, staticRenderFns } from "./bannersEditar.vue?vue&type=template&id=313317c2&scoped=true&"
import script from "./bannersEditar.vue?vue&type=script&lang=js&"
export * from "./bannersEditar.vue?vue&type=script&lang=js&"
import style0 from "./bannersEditar.vue?vue&type=style&index=0&id=313317c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313317c2",
  null
  
)

export default component.exports